const HOVER_SCALE = 1.1;

/**
 * View More ボタンをホバー時に 1.1 倍へ拡大しながら 1 回転させる
 */
function initViewMoreRotate(root: HTMLElement): void {
  if (root.dataset.jsViewMoreInitialized === "true") return;

  const outer = root.querySelector<SVGGElement>("[data-js-view-more-outer]");
  if (!outer) return;

  root.dataset.jsViewMoreInitialized = "true";

  let currentRotation = 0;
  let targetRotation = 0;
  let isHovered = false;
  let isAnimating = false;

  const setTransform = (scale: number, rotation: number): void => {
    outer.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
  };

  const onEnter = (): void => {
    if (isHovered) return;
    isHovered = true;
    isAnimating = true;
    targetRotation = currentRotation + 360;
    setTransform(HOVER_SCALE, targetRotation);
  };

  const onTransitionEnd = (event: TransitionEvent): void => {
    if (event.target !== outer || event.propertyName !== "transform") return;
    if (!isAnimating) return;
    isAnimating = false;
    currentRotation = targetRotation;
  };

  const onLeave = (): void => {
    isHovered = false;
    if (isAnimating) {
      currentRotation = targetRotation;
      isAnimating = false;
    }
    setTransform(1, currentRotation);
  };

  outer.addEventListener("transitionend", onTransitionEnd);
  root.addEventListener("mouseenter", onEnter);
  root.addEventListener("mouseleave", onLeave);
  root.addEventListener("focusin", onEnter);
  root.addEventListener("focusout", onLeave);

  setTransform(1, currentRotation);
}

export function initViewMoreRotateAll(): void {
  const hoverMedia = window.matchMedia("(hover: hover) and (pointer: fine)");
  if (!hoverMedia.matches) return;

  document.querySelectorAll<HTMLElement>("[data-js-view-more]").forEach(initViewMoreRotate);
}
